// @flow
import React from "react";
import I18n from "../../../i18n/I18n";
import enhanceWithClickOutside from "react-click-outside";
import Button from "../../common/button/Button";
import styles from "./ExportList.scss";
import Icon from "../../common/Icon";

type Props = {
  exportStock: Function
};

type State = {
  isOpened: boolean
};

class ExportList extends React.Component<Props, State> {
  state = {
    isOpened: false
  };

  toggleList = () => {
    this.setState(prevState => ({
      isOpened: !prevState.isOpened
    }));
  };

  handleClickOutside = () => {
    this.setState({ isOpened: false });
  };

  render() {
    const { exportStock, exportOffer } = this.props;
    const { isOpened } = this.state;
    return (
      <div className={styles.container}>
        <Button
          className={styles.filterButton}
          variant="transparent"
          onClick={this.toggleList}
        >
          <div>
            <span className={styles.label}>{I18n.getText("products.export-label")}</span>
          </div>
          <Icon name={isOpened ? "caret-up" : "caret-down"} />
        </Button>
        {isOpened && (
          <div className={styles.popDown}>
            <ul>
              <li
              onClick={exportOffer}
              >
                <Icon name="download" className={styles.icon} />
            {I18n.getText("products.export-offer")}
              </li>
              <li onClick={exportStock}>
                <Icon name="download" className={styles.icon} />
            {I18n.getText("products.export-offer-stock")}
              </li>
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default enhanceWithClickOutside(ExportList);



// WEBPACK FOOTER //
// ./src/components/products/exportList/ExportList.js